import { call, put, takeLatest } from 'redux-saga/effects';

import httpClient from '../../utils/httpClient';
import { PAYMENT_BUY_SUBSCRIPTION_REQUEST, PAYMENT_CANCEL_SUBSCRIPTION_REQUEST } from '../actions/actionTypes';
import { cancelSubscriptionError, cancelSubscriptionSuccess } from '../actions/payment';

// cancel
function cancelSubscriptionApiCall() {
  return httpClient.post(`api/payment/cancel`);
}

function* cancelSubscriptionSaga() {
  try {
    const { data: cancelResult } = yield call(cancelSubscriptionApiCall);
    console.log('cancelSubscriptionApiCall res', cancelResult);

    yield put(cancelSubscriptionSuccess(cancelResult));
  } catch ({ response }) {
    console.log('cancelSubscriptionSaga error', response);

    let message = 'Cannot cancel subscription. Please try again later.';

    if (response && response.data && response.data.Message) {
      message = response.data.Message;
    }

    if (response && response.data) {
      message = response.data;
    }

    yield put(cancelSubscriptionError(message));
  }
}

export function* cancelSubscriptionWatcher() {
  yield takeLatest(PAYMENT_CANCEL_SUBSCRIPTION_REQUEST, cancelSubscriptionSaga);
}

// send payment
function buySubscriptionApiCall({ token, fingerprint }) {
  return httpClient.post(`api/payment/subscribe`, {
    brick_token: token,
    brick_fingerprint: fingerprint,
  });
}

function* buySubscriptionSaga({ payload }) {
  try {
    const { data: paymentResult } = yield call(buySubscriptionApiCall, payload);
    console.log('buySubscriptionSaga res', paymentResult);

    yield put(cancelSubscriptionSuccess(Number(paymentResult)));
  } catch ({ response }) {
    console.log('buySubscriptionSaga error', response);

    let message = 'Cannot purchase the subscription. Please try again.';

    if (response && response.data && response.data.Message) {
      message = response.data.Message;
    } else if (response && response.data) {
      message = response.data;
    }

    yield put(cancelSubscriptionError(message));
  }
}

export function* buySubscriptionWatcher() {
  yield takeLatest(PAYMENT_BUY_SUBSCRIPTION_REQUEST, buySubscriptionSaga);
}
